"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _erisEcdsa = _interopRequireDefault(require("eris-ecdsa"));

var _bs = _interopRequireDefault(require("bs58"));

var _moment = _interopRequireDefault(require("moment"));

var _semanticUiReact = require("semantic-ui-react");

var _constants = require("../../constants");

var _lib = require("../../utils/lib");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

//
// The following (optional) callbacks may be called:
// onCancel
// onConfirm
//
//
// We require the following props mapped using mapStateToProps:
// account
// values (form values - see below)
// amountMinUnit // TODO -- get rid of this, instead use the new 2-step withdrawal API endpoints (build tx, then sign tx).
// user
// selectedMemberId
//
//
// Expected form values:
//
// For type === "crypto":
// destination, destinationId, amount, assetType, fundsDesignation
//
// For type === "fiat":
// amount, assetType, fundsDesignation, linkedAssetAccount
//
var WithdrawalConfirm = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(WithdrawalConfirm, _Component);

  var _super = _createSuper(WithdrawalConfirm);

  function WithdrawalConfirm() {
    var _this;

    (0, _classCallCheck2["default"])(this, WithdrawalConfirm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      password: ''
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (e, obj) {
      var change = (0, _defineProperty2["default"])({}, obj.name, obj.value);

      _this.setState(change);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "confirmWithdrawal", function () {
      var _this$props = _this.props,
          user = _this$props.user,
          onConfirm = _this$props.onConfirm;

      var privateKey = _erisEcdsa["default"].privateKeyFromPassword(user.authId, _this.state.password);

      var payload = _this.getWithdrawalPayload(privateKey);

      _this.props.onConfirm(payload);
    });
    return _this;
  }

  (0, _createClass2["default"])(WithdrawalConfirm, [{
    key: "getWithdrawalPayload",
    value: function getWithdrawalPayload(privateKey) {
      switch (this.props.type) {
        case 'fiat':
          return this.getFiatWithdrawal(privateKey);

        case 'crypto':
          return this.getCryptoWithdrawal(privateKey);

        default:
          throw new Error('Unsupported withdrawal type: ' + this.props.type);
      }
    }
  }, {
    key: "getFiatWithdrawal",
    value: function getFiatWithdrawal(privateKey) {
      var _this$props2 = this.props,
          payMethod = _this$props2.payMethod,
          account = _this$props2.account,
          user = _this$props2.user,
          selectedMemberId = _this$props2.selectedMemberId,
          values = _this$props2.values;
      var amount = values.amount,
          assetType = values.assetType,
          fundsDesignation = values.fundsDesignation,
          linkedAssetAccount = values.linkedAssetAccount;
      var accountId = account.accountId;

      var nonce = _moment["default"].now().toString();

      var msg = [selectedMemberId, user.authId, linkedAssetAccount.hashId, assetType, amount, nonce];

      var sig = _erisEcdsa["default"].signMsgBs58(JSON.stringify(msg), privateKey);

      var payload = {
        accountId: accountId,
        payMethod: payMethod,
        linkedMemberAssetAccountId: linkedAssetAccount.id,
        amount: amount,
        fundsDesignation: fundsDesignation,
        sequenceId: JSON.stringify({
          msg: msg,
          sig: sig
        })
      };
      return payload;
    }
  }, {
    key: "getCryptoWithdrawal",
    value: function getCryptoWithdrawal(privateKey) {
      var _this$props3 = this.props,
          user = _this$props3.user,
          amountMinUnit = _this$props3.amountMinUnit,
          account = _this$props3.account,
          selectedMemberId = _this$props3.selectedMemberId,
          values = _this$props3.values;

      var accountId = _lodash["default"].get(account, 'accountId', ''); // We cannot sign a crypto withdrawal if we don't have amountMinUnit.
      // So we shouldn't even try. (We shouldn't even get here because the
      // button will be disabled, so this is just a sanity check.)


      if (_lodash["default"].isUndefined(amountMinUnit)) {
        // Rather not throw an Error here because we don't want to crash the GUI.
        console.error("Could not sign because we don't have amountMinUnit.");
        return;
      } // create message here
      // message is a string that is is a json array that goes: [username,address,amount,nonce]


      var destination = values.destination,
          destinationId = values.destinationId,
          amount = values.amount,
          assetType = values.assetType,
          fundsDesignation = values.fundsDesignation;

      var nonce = _moment["default"].now().toString();

      var amountMinUnitString = amountMinUnit.toString();
      var msg = [selectedMemberId, user.authId, destination, assetType, amountMinUnitString, nonce];

      var sig = _erisEcdsa["default"].signMsgBs58(JSON.stringify(msg), privateKey);

      var payload = {
        accountId: accountId,
        amount: amount,
        fundsDesignation: fundsDesignation,
        linkedMemberAssetAccountId: destinationId,
        sequenceId: JSON.stringify({
          msg: msg,
          sig: sig
        })
      };
      return payload;
    }
  }, {
    key: "formatAmount",
    value: function formatAmount(amount, currency) {
      switch (this.props.type) {
        case 'fiat':
          return (0, _lib.format)(amount, {
            type: 'fiat',
            currency: currency,
            truncate: 2
          });

        default:
          // format() doesn't add currency type for crypto so we still have to add it here.
          return "".concat((0, _lib.format)(amount, {
            type: 'crypto',
            currency: currency
          }), " ").concat(currency);
      }
    }
  }, {
    key: "enableConfirm",
    value: function enableConfirm() {
      // For crypto, we should not enable the confirm button until we have a value for amountMinUnit.
      if (this.props.type === 'crypto' && _lodash["default"].isUndefined(this.props.amountMinUnit)) return false;
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          onCancel = _this$props4.onCancel,
          account = _this$props4.account,
          title = _this$props4.title,
          fundingPassword = _this$props4.fundingPassword;
      var _this$props$values = this.props.values,
          destinationLabel = _this$props$values.destinationLabel,
          amount = _this$props$values.amount,
          assetType = _this$props$values.assetType,
          fundsDesignation = _this$props$values.fundsDesignation,
          fee = _this$props$values.fee;

      var accountId = _lodash["default"].get(account, 'accountId', '');

      var accountLabel = _lodash["default"].get(account, 'label', '');

      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        icon: "arrow circle up",
        content: title
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Content, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "vert-flex"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Statistic.Group, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Statistic, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Statistic.Label, null, "Sending"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Statistic.Value, {
        name: "amount"
      }, this.formatAmount(amount, assetType)), this.props.type === 'crypto' ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Statistic.Label, null, "Fees = ", this.formatAmount(this.props.values.fee, assetType)) : null)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, {
        className: "transaction-confirm"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, {
        name: "from",
        massive: true,
        label: "From:",
        control: _semanticUiReact.Input,
        type: "text",
        value: accountLabel,
        readOnly: true
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, {
        name: "to",
        control: _semanticUiReact.Input,
        massive: true,
        label: "To:",
        type: "text",
        value: destinationLabel,
        readOnly: true
      }), !_lodash["default"].isEmpty(fundsDesignation) ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, {
        name: "designation",
        massive: true,
        label: "Funds Designation:",
        control: _semanticUiReact.Input,
        type: "text",
        value: (0, _lib.getFundsDesignationTextByValue)(fundsDesignation),
        readOnly: true
      }) : null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, null, " Please enter your ", fundingPassword, ":"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        name: "password",
        type: "password",
        fluid: true,
        onChange: this.handleChange
      })))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Actions, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        color: "red",
        id: "cancel",
        onClick: onCancel
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "remove"
      }), " Cancel"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        color: "green",
        id: "confirm",
        onClick: this.confirmWithdrawal,
        disabled: !this.enableConfirm()
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "check"
      }), " Confirm")));
    }
  }]);
  return WithdrawalConfirm;
}(_react.Component);

WithdrawalConfirm.propTypes = {
  // Callbacks
  onCancel: _propTypes["default"].func,
  onConfirm: _propTypes["default"].func,
  // Some limited customization
  title: _propTypes["default"].string,
  fundingPassword: _propTypes["default"].string,
  type: _propTypes["default"].string.isRequired,
  payMethod: _propTypes["default"].string,
  // Required when type === 'fiat'
  amountMinUnit: _propTypes["default"].number,
  // Required when type === 'crypto' (if undefined, confirm button is disabled)
  user: _propTypes["default"].object.isRequired,
  // Shape is standard user from redux store
  account: _propTypes["default"].object.isRequired,
  // Shape is standard account from redux store
  selectedMemberId: _propTypes["default"].string.isRequired,
  values: _propTypes["default"].shape({
    destinationLabel: _propTypes["default"].string.isRequired,
    amount: _propTypes["default"].string.isRequired,
    assetType: _propTypes["default"].string.isRequired,
    fundsDesignation: _propTypes["default"].string.isRequired,
    // Required when type === 'fiat'
    linkedAssetAccount: _propTypes["default"].shape({
      hashId: _propTypes["default"].string,
      id: _propTypes["default"].string
    }),
    // Required when type === 'crypto'
    destination: _propTypes["default"].string,
    destinationId: _propTypes["default"].string
  }).isRequired
};
WithdrawalConfirm.defaultProps = {
  onCancel: function onCancel() {},
  onConfirm: function onConfirm() {},
  title: 'Please confirm your withdrawal',
  fundingPassword: 'funding password'
};
var _default = WithdrawalConfirm;
exports["default"] = _default;